import './slider.scss';
import Glide from '@glidejs/glide';

const slides = document.querySelectorAll('.slider-wrapper');
slides.forEach(sliderElement => {
    const hideOnMobile = sliderElement.classList.contains('hide-on-mobile');
    const viewportWidth = window.innerWidth;
    if (viewportWidth >= 992 || hideOnMobile === false) {
        new Glide(sliderElement, {
            type             : 'slider',
            startAt          : 0,
            perView          : 1,
            autoplay         : sliderElement.getAttribute('data-autoplay-interval'),
            animationDuration: 0,
            rewindDuration   : 0,
            swipeThreshold   : false,
            dragThreshold    : false,
        }).mount();
    }
});
